import dayjs, { ConfigType } from "dayjs";
import "dayjs/locale/ko";
import "dayjs/locale/zh-tw";
import "dayjs/locale/ja";
import arraySupport from "dayjs/plugin/arraySupport";
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale("ko");
dayjs.extend(arraySupport);
dayjs.extend(localizedFormat)
dayjs.extend(advancedFormat);

const dayjsCustom = (day?: number | string | number[]) => {
  if (!day) return dayjs();
  if (Array.isArray(day)) {
    const newDay = day.map((d, ind) => {
      if (ind === 1) return d - 1;
      else if (ind === 6) return d / 1000000;
      else return d;
    });

    return dayjs(newDay as ConfigType);
  }
  return dayjs(day);
};

export default dayjsCustom;
